const LONG_LIVED_FLAGS = {
  'show-msp-access-request-feature': false,
};

export const FeatureFlags = {
  ...LONG_LIVED_FLAGS,
  'enable-org-lookup-signup': false,
};

export type FeatureFlagKeys = keyof typeof FeatureFlags;
